import { useTranslation } from 'react-i18next';

export const useLanguage = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
    localStorage.setItem('i18nextLng', language);
  };

  const getCurrentLanguage = () => i18n.language;

  const getAvailableLanguages = () => ['en', 'fr'];

  return {
    changeLanguage,
    getCurrentLanguage,
    getAvailableLanguages,
  };
};
